/* unplugin-vue-components disabled */import script from "./LectureCard.vue?vue&type=script&setup=true&lang=js"
export * from "./LectureCard.vue?vue&type=script&setup=true&lang=js"

import "./LectureCard.vue?vue&type=style&index=0&id=4b6af67c&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上电-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b6af67c"]])

export default __exports__